import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private excludedUrls = [
    '/api/oidc/',
    '/api/auth/login',
    '/api/auth/register',
    '/api/partner-lead',
  ];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isExcluded(req.url)) {
      return next.handle(req);
    }

    return this.oidcSecurityService.getAccessToken().pipe(
      take(1),
      switchMap((token) => {
        if (!token) return next.handle(req);

        return next.handle(
          req.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          }),
        );
      }),
    );
  }

  private isExcluded(url: string): boolean {
    return this.excludedUrls.some((excludedUrl) => url.includes(excludedUrl));
  }
}
